import { IConfig } from '@cian/config/shared';
import { PERSONAL_DATA_AGREEMENT_LINK } from '../../../constants/links';

const PERSONAL_DATA_AGREEMENT_KEY = 'newbuilding-consultants-frontend.personalDataAgreementUrl';

export const getPersonalDataAgreementUrl = (config: IConfig): string => {
  return config.get<string>(PERSONAL_DATA_AGREEMENT_KEY) || PERSONAL_DATA_AGREEMENT_LINK;
};
